var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "c-search-box",
        { on: { enter: _vm.getList } },
        [
          _c("template", { slot: "search" }, [
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3" },
              [
                _c("c-select", {
                  attrs: {
                    codeGroupCd: "SENIOR_CLASS_CD",
                    type: "search",
                    itemText: "codeName",
                    itemValue: "code",
                    name: "seniorClassCd",
                    label: "LBL0010238",
                  },
                  model: {
                    value: _vm.searchParam.seniorClassCd,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParam, "seniorClassCd", $$v)
                    },
                    expression: "searchParam.seniorClassCd",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3" },
              [
                _c("c-select", {
                  attrs: {
                    comboItems: _vm.useFlagItems,
                    type: "search",
                    itemText: "codeName",
                    itemValue: "code",
                    name: "useFlag",
                    label: "LBLUSEFLAG",
                  },
                  model: {
                    value: _vm.searchParam.useFlag,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParam, "useFlag", $$v)
                    },
                    expression: "searchParam.useFlag",
                  },
                }),
              ],
              1
            ),
          ]),
        ],
        2
      ),
      _c(
        "c-table",
        {
          ref: "table",
          attrs: {
            title: "선임명 목록",
            columns: _vm.grid.columns,
            data: _vm.grid.data,
            editable: _vm.editable,
          },
          scopedSlots: _vm._u([
            {
              key: "customArea",
              fn: function ({ props, col }) {
                return [
                  col.name === "educationCourseNames"
                    ? [
                        _c("c-tag", {
                          attrs: {
                            editable: _vm.editable,
                            icon: "person_outline",
                            itemText: "educationCourseName",
                            itemValue: "check",
                            name: "eduList",
                          },
                          on: {
                            addTag: function ($event) {
                              return _vm.addEduMaster(props.row)
                            },
                            removeTag: (item) =>
                              _vm.removeEduMaster(item, props.row),
                          },
                          model: {
                            value: props.row.eduList,
                            callback: function ($$v) {
                              _vm.$set(props.row, "eduList", $$v)
                            },
                            expression: "props.row.eduList",
                          },
                        }),
                      ]
                    : _vm._e(),
                ]
              },
            },
          ]),
        },
        [
          _c(
            "template",
            { slot: "table-button" },
            [
              _c(
                "q-btn-group",
                { attrs: { outline: "" } },
                [
                  _vm.editable
                    ? _c("c-btn", {
                        attrs: {
                          label: "LBLADD",
                          showLoading: true,
                          icon: "add",
                        },
                        on: { btnClicked: _vm.add },
                      })
                    : _vm._e(),
                  _vm.editable
                    ? _c("c-btn", {
                        attrs: {
                          url: _vm.saveUrl,
                          isSubmit: _vm.isSave,
                          param: _vm.grid.data,
                          mappingType: "POST",
                          label: "LBLSAVE",
                          icon: "save",
                        },
                        on: {
                          beforeAction: _vm.saveSenior,
                          btnCallback: _vm.saveCallback,
                        },
                      })
                    : _vm._e(),
                  _c("c-btn", {
                    attrs: { label: "LBLSEARCH", icon: "search" },
                    on: { btnClicked: _vm.getList },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }